import Marquee from "react-fast-marquee";

const ITEMS = ["Cleaning", "Meal Prep", "Laundry", "Organisation", "Dog Walking", "Babysitting", "Errands", "Bond Cleaning"];

export const Ribbon = () => (
  <div data-testid="editorial-ribbon" className="bg-[#D1DEC9] border-y border-[#C7D4BE] py-8 overflow-hidden">
    <Marquee speed={28} gradient={false}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-4xl md:text-6xl text-[#1A362D] px-10 md:px-16">{item}</span>
          <span className="w-2 h-2 rounded-full bg-[#C26D5C]" />
        </span>
      ))}
    </Marquee>
  </div>
);
